// extracted by mini-css-extract-plugin
export default {"quote":"quote_quote__ChcGq","content":"quote_content__8NVOb","leftQuote":"quote_leftQuote__CtR8O","rightQuote":"quote_rightQuote__lY96X","author":"quote_author__m1iBP"};